const SMALL_ELEMENT_VIEW_PERCENT = 0.5 // 小元素曝光区域比例，大于一定的比例才算曝光
const BIG_ELEMENT_VIEW_PERCENT = 0.3 // 大元素曝光区域比例，大于一定的比例才算曝光
const BIG_ELEMENT_VIEW_MIN_PIXEL = 242500 // 大元素最少像素

/**
 * 曝光埋点
 */
export default {
  install(app) {
    let bigViewIntersectionObserver = null
    let smallViewIntersectionObserver = null
    function getIntersectionObserver(el) {
      const rect = el.getBoundingClientRect()
      const pixel = rect.width * rect.height * window.devicePixelRatio
      let intersectionObserver = null
      if (pixel >= BIG_ELEMENT_VIEW_MIN_PIXEL) {
        if (!bigViewIntersectionObserver) {
          bigViewIntersectionObserver = new IntersectionObserver(
            (entries) => {
              for (const entry of entries) {
                if (!entry.target.viewed && entry.intersectionRatio) {
                  const event = new CustomEvent('view', {
                    detail: {}
                  })
                  entry.target.dispatchEvent(event)
                  entry.target.viewed = true
                }
              }
            },
            {
              threshold: BIG_ELEMENT_VIEW_PERCENT
            }
          )
        }
        intersectionObserver = bigViewIntersectionObserver
      } else {
        if (!smallViewIntersectionObserver) {
          smallViewIntersectionObserver = new IntersectionObserver(
            (entries) => {
              for (const entry of entries) {
                if (!entry.target.viewed && entry.intersectionRatio) {
                  const event = new CustomEvent('view', {
                    detail: {}
                  })
                  entry.target.dispatchEvent(event)
                  entry.target.viewed = true
                }
              }
            },
            {
              threshold: SMALL_ELEMENT_VIEW_PERCENT
            }
          )
        }
        intersectionObserver = smallViewIntersectionObserver
      }
      return intersectionObserver
    }

    /**
     * 记录曝光
     */
    app.directive('log-view', {
      mounted(el) {
        const intersectionObserver = getIntersectionObserver(el)
        intersectionObserver.observe(el)
      },
      beforeUnmount(el) {
        const intersectionObserver = getIntersectionObserver(el)
        intersectionObserver.unobserve(el)
      }
    })
  }
}
